import React from "react";
import { AssociatePlansContainer } from "../../../containers";

const AssociatePlans = (props) => {
  return <AssociatePlansContainer />;
};

export default AssociatePlans;
